// Replica of the fake "Verification Steps" popup styled like a real reCAPTCHA challenge card
export default function VerifyWindow({ onClose, onAnnotate, isMac }) {
  const fakeVerificationId = '8Z1k5L0mP7x9C3w2V323h947hd4dh58'

  const windowsSteps = [
    <>Press & hold <strong>Windows Key ⊞</strong> + <strong>R</strong></>,
    <>Press <strong>Ctrl</strong> + <strong>V</strong> in the window that opens</>,
    <>Press <strong>Enter</strong> to finish</>,
  ]

  const macSteps = [
    <>Press <strong>⌘ Command</strong> + <strong>Space</strong></>,
    <>Type <strong>Terminal</strong> and press <strong>Enter</strong></>,
    <>Press <strong>⌘ Command</strong> + <strong>V</strong>, then <strong>Enter</strong></>,
  ]

  const steps = isMac ? macSteps : windowsSteps

  return (
    <>
      {/* Invisible overlay to catch outside clicks */}
      <div className="fixed inset-0 z-10" onClick={onClose} />

      {/* Card wrapper — positions arrow on the RIGHT edge pointing toward the captcha */}
      <div
        className="relative z-20"
        style={{ width: 320 }}
        onMouseEnter={() => onAnnotate('verify')}
        onMouseLeave={() => onAnnotate(null)}
      >
        {/* Arrow pointing RIGHT — desktop only (md+) */}
        <div className="hidden md:block" style={{
          position: 'absolute', top: 20, right: -9, width: 0, height: 0,
          borderTop: '9px solid transparent', borderBottom: '9px solid transparent',
          borderLeft: '9px solid #d3d3d3', zIndex: 1,
        }} />
        <div className="hidden md:block" style={{
          position: 'absolute', top: 21, right: -8, width: 0, height: 0,
          borderTop: '8px solid transparent', borderBottom: '8px solid transparent',
          borderLeft: '8px solid #fff', zIndex: 2,
        }} />

        {/* Arrow pointing UP — small screens only */}
        <div className="block md:hidden" style={{
          position: 'absolute', top: -9, right: 24, width: 0, height: 0,
          borderLeft: '9px solid transparent', borderRight: '9px solid transparent',
          borderBottom: '9px solid #d3d3d3', zIndex: 1,
        }} />
        <div className="block md:hidden" style={{
          position: 'absolute', top: -8, right: 25, width: 0, height: 0,
          borderLeft: '8px solid transparent', borderRight: '8px solid transparent',
          borderBottom: '8px solid #f9f9f9', zIndex: 2,
        }} />

        {/* Card */}
        <div style={{
          background: '#fff',
          border: '1px solid #d3d3d3',
          borderRadius: 4,
          boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
          overflow: 'hidden',
          fontFamily: 'Roboto, Arial, sans-serif',
        }}>

          {/* Header — reCAPTCHA branding bar */}
          <div style={{
            background: '#f9f9f9',
            borderBottom: '1px solid #d3d3d3',
            padding: '10px 14px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}>
            <div>
              <div style={{ fontSize: 13, fontWeight: 500, color: '#202124' }}>
                Verify you are human
              </div>
              <div style={{ fontSize: 11, color: '#70757a', marginTop: 1 }}>
                Complete the security check to continue
              </div>
            </div>
            <img
              src="https://wpforms.com/wp-content/uploads/2024/08/google-recaptcha-logo.png"
              alt="reCAPTCHA"
              style={{ width: 28, height: 28, objectFit: 'contain', opacity: 0.7 }}
            />
          </div>

          {/* Body — steps */}
          <div style={{ padding: '14px 14px 10px' }}>
            <p style={{ fontSize: 12, color: '#5f6368', margin: '0 0 10px' }}>
              To complete verification, please:
            </p>

            <ol style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: 9 }}>
              {steps.map((item, i) => (
                <li key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 10 }}>
                  <span style={{
                    minWidth: 20,
                    height: 20,
                    borderRadius: '50%',
                    background: '#1A73E8',
                    color: '#fff',
                    fontSize: 11,
                    fontWeight: 600,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                    marginTop: 1,
                  }}>
                    {i + 1}
                  </span>
                  <span style={{ fontSize: 12, color: '#202124', lineHeight: 1.5 }}>{item}</span>
                </li>
              ))}
            </ol>

            {/* Verification ID */}
           <div
  style={{
    marginTop: 12,
    background: '#f1f3f4',
    borderRadius: 3,
    padding: '7px 9px',
    fontSize: 11,
    color: '#5f6368',
    fontFamily: 'monospace',
    userSelect: 'none',        // disables text selection
    WebkitUserSelect: 'none',  // for Safari
    MozUserSelect: 'none',     // for Firefox
    msUserSelect: 'none',      // for IE/Edge (legacy)
  }}
>
              I am not a robot - reCAPTCHA Verification ID: {fakeVerificationId}
            </div>
          </div>

          {/* Footer */}
          <div style={{
            borderTop: '1px solid #e0e0e0',
            padding: '8px 14px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}>
            <span style={{ fontSize: 10, color: '#9aa0a6' }}>
              reCAPTCHA · Privacy · Terms
            </span>
            <button
              type="button"
              disabled
              style={{
                background: '#1A73E8',
                color: '#fff',
                border: 'none',
                borderRadius: 3,
                padding: '5px 14px',
                fontSize: 11,
                fontWeight: 600,
                cursor: 'not-allowed',
                opacity: 0.6,
                letterSpacing: '0.04em',
                textTransform: 'uppercase',
              }}
            >
              Verify
            </button>
          </div>

        </div>
      </div>
    </>
  )
}
